<ion-app>
  <div *ngIf="isDesktop" class="no-web-access-content">
    <img src="assets/no-web-access.jpeg" alt="" class="no-web-access-image">
    <div class="alert-text">
      <div class="text-content">
        <p class="main-text">Our application is optimised for Mobile view only.</p>
        <p class="sub-text">Access <a href="https://app.weightmantra.com" target="_blank" rel="noopener noreferrer">app.weightmantra.com</a> on Mobile</p>
      </div>
    </div>
  </div>
  <div *ngIf="showSplash && !isDesktop" class="splash">
    <div class="logo">
      <img src="./assets/icons/logo.png" />
    </div>
  </div>
  <ion-menu contentId="main-content" side="start" *ngIf="!isDesktop">
    <ion-header mode="ios" class="menu header-menu">
      <ion-toolbar style="height: auto !important" class="menu header-menu">
        <ion-row>
          <ion-avatar
            style="
              margin: auto;
              margin-top: 1rem;
              border: 2px solid #01a3a4;
              width: 75px;
              height: 75px;
            "
            class="ion-text-center"
          >
            <img
              *ngIf="
                (!profilePic || profilePic == '') &&
                (!profileInititals || profileInititals == '')
              "
              src="assets/icons/logo.png"
            />
            <img *ngIf="profilePic && profilePic != ''" [src]="profilePic" />
            <span
              *ngIf="!profilePic || profilePic == ''"
              style="
                position: relative;
                top: 20%;
                font-size: 2rem;
                color: #01a3a4;
                font-weight: bold;
              "
              >{{ profileInititals }}</span
            >
          </ion-avatar>
        </ion-row>
        <ion-row>
          <div class="profile-name">
            <span style="color: #01a3a4">{{ profileName }}</span>
          </div>
        </ion-row>

        <ion-row>
          <ion-col class="text-center">
            <div
              style="
                border-top: 1px solid #01a3a4;
                width: 60%;
                display: inline-block;
              "
            ></div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="text-center">
            <p class="small-text" style="color: #01a3a4" *ngIf="freePlanActive">
              Your FREE plan is active
            </p>
            <p
              class="small-text"
              style="color: #01a3a4"
              *ngIf="premiumPlanExpired"
            >
              Your PREMIUM plan is expired on:
            </p>
            <p
              class="small-text"
              style="color: #01a3a4"
              *ngIf="premiumPlanActive"
            >
              Your PREMIUM plan will expire on :
            </p>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="premiumPlanExpired || premiumPlanActive">
          <ion-col class="text-center">
            <p class="big-text" style="color: #01a3a4">{{ expiryDate }}</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="text-center" style="padding: 0 1rem">
            <ion-menu-toggle auto-hide="true">
              <ion-button
                mode="ios"
                shape="round"
                class="button-green button-full"
                (click)="gotoUpgrade()"
                style="
                  border-radius: 5px;
                  --background: #deb221;
                  border: 1px solid #deb221;
                  --color: #fff;
                "
              >
                Upgrade my Plan
              </ion-button>
            </ion-menu-toggle>
          </ion-col>
        </ion-row>
      </ion-toolbar>
    </ion-header>
    <ion-content class="menu">
      <div style="border-bottom: 1px solid #eee" class="ion-margin-top"></div>
      <!-- <ion-list class="ion-no-padding menu-side" lines="none">
        <ion-menu-toggle auto-hide="true">
          <div class="d-flex-center py-6">
              <img class="user-image" src="assets/img/manjari-profile.jpg" />
                <div>
                  <p (click)="openLink('https://manjariwellness.com/about-us/')" class="about-menu">
                    About Manjari Chandra              
                  </p>
                  <p  class="about-menu" (click)="appIntro()">
                  App Intro
                  </p>
                </div>           
            </div>
          <ion-item [routerLink]="['notification']">
            <ion-icon name="notifications" slot="start" style="color:#707070"></ion-icon>
            <ion-label>Notifications setting</ion-label>
            <! -- <h3 slot="end">
                      <span style="padding-left: 1rem;padding-right:1rem;">2</span>
                    </h3> -- >
          </ion-item>
          <! -- <ion-item [routerLink]="['faq']" lines="none">
            <ion-icon name="help" slot="start" style="color:#707070"></ion-icon>
            <ion-label>Help</ion-label>
          </ion-item> -- >
          <! -- <ion-item>
            <ion-icon name="settings" slot="start"></ion-icon>
            <ion-label>Account</ion-label>
          </ion-item> -- >
          <ion-item lines="none">
            <ion-icon name="share-social" slot="start" style="color:#707070"></ion-icon>
            <ion-label>Share with your friends</ion-label>
          </ion-item>
          <ion-item lines="none" (click)="openLink('https://smartdietplanner.com/terms')">
            <ion-icon name="document-text" slot="start" style="color:#707070"></ion-icon>
            <ion-label>Term and conditions</ion-label>
          </ion-item>
          <ion-item lines="none" (click)="openLink('https://smartdietplanner.com/policy')">
            <ion-icon name="document-lock" slot="start" style="color:#707070"></ion-icon>
            <ion-label>Privacy Policy</ion-label>
          </ion-item>
          <ion-item lines="none" (click)="openLink('https://smartdietplanner.com/appinfo/')">
            <ion-icon name="information" slot="start" style="color:#707070"></ion-icon>
            <ion-label> Source of information</ion-label>
          </ion-item>
          <ion-item lines="none" (click)="restore()" *ngIf="isIOSDevice">
            <ion-icon name="refresh-outline" slot="start" style="color:#707070"></ion-icon>
            <ion-label> Restore Purchase</ion-label>
          </ion-item> -->

      <!-- <ion-item lines="none" (click)="gotoDiet()">
              <img slot="start" style="width: 7%;
              height: auto;" src="./assets/icons/Group 147.svg">
              <ion-label> Personalise Now</ion-label>
            </ion-item> -->
      <!-- <ion-item (click)="unSubscribe()">
            <ion-icon name="document-text" slot="start"></ion-icon>
            <ion-label>Unsubscribe plan</ion-label>
          </ion-item> -- >
          <br>
          <ion-item (click)="logout()" lines="none" class="ion-text-center">
            <ion-button mode="ios" size="medium" shape="round" style="--background:#01A3A4;border:1px solid #01A3A4; --color:#fff;border-radius: 25px;left: 26%;
              position: relative;">
              <ion-icon name="log-out" slot="start" style="color:#fff"></ion-icon>
              Logout
            </ion-button>
          </ion-item>
        </ion-menu-toggle>
      </ion-list> -->

      <ion-list class="ion-no-padding menu-side ion-text-left" lines="none">
        <ion-menu-toggle auto-hide="true">
          <!-- <ion-item lines="none" (click)="openLink('https://manjariwellness.com/about-us/')" class="ion-no-padding ion-margin-horizontal">
            <ion-img src="assets/images/Artboard3.svg"></ion-img>
            <ion-label class="ion-margin-start">About Manjari Chandra</ion-label>
          </ion-item> -->

          <!-- <ion-item lines="none" (click)="goToTodaysCalorieCount()" class="ion-no-padding ion-margin-horizontal">
            <ion-icon name="star-outline"></ion-icon>
            <ion-label class="ion-margin-start"> Today's Calorie Count</ion-label>
          </ion-item> -->

          <ion-item
            lines="none"
            [routerLink]="['about-us']"
            class="ion-no-padding ion-margin-horizontal"
          >
            <ion-img src="assets/images/Artboard3.svg"></ion-img>
            <ion-label class="ion-margin-start">About Us</ion-label>
          </ion-item>

          <ion-item
            lines="none"
            (click)="appIntro()"
            class="ion-no-padding ion-margin-horizontal"
          >
            <ion-img src="assets/images/Artboard4.svg"></ion-img>
            <ion-label class="ion-margin-start">App Intro</ion-label>
          </ion-item>

          <ion-item
            lines="none"
            [routerLink]="['referral-transactions']"
            class="ion-no-padding ion-margin-horizontal"
            *ngIf="isAvailableReffer"
          >
            <ion-icon name="people-circle-outline"></ion-icon>
            <ion-label class="ion-margin-start">Refferal</ion-label>
          </ion-item>

          <ion-item
            lines="none"
            [routerLink]="['notification']"
            class="ion-no-padding ion-margin-horizontal"
          >
            <ion-img src="assets/images/Artboard5.svg"></ion-img>
            <ion-label class="ion-margin-start"
              >Notifications setting</ion-label
            >
          </ion-item>

          <ion-item
            lines="none"
            [routerLink]="['blog']"
            class="ion-no-padding ion-margin-horizontal"
          >
            <ion-icon name="document-text-outline"></ion-icon>
            <ion-label class="ion-margin-start">Q & A</ion-label>
          </ion-item>

          <ion-item lines="none" class="ion-no-padding ion-margin-horizontal">
            <ion-img
              src="assets/img/share-icon.png"
              style="width: 20px"
            ></ion-img>
            <ion-label class="ion-margin-start"
              >Share with your friends</ion-label
            >
          </ion-item>
          <ion-item
            lines="none"
            (click)="openLink('https://smartdietplanner.com/terms')"
            class="ion-no-padding ion-margin-horizontal"
          >
            <ion-img src="assets/images/Artboard8.svg"></ion-img>
            <ion-label class="ion-margin-start">Term and conditions</ion-label>
          </ion-item>
          <ion-item
            lines="none"
            (click)="openLink('https://smartdietplanner.com/policy')"
            class="ion-no-padding ion-margin-horizontal"
          >
            <ion-img src="assets/images/Artboard9.svg"></ion-img>
            <ion-label class="ion-margin-start">Privacy Policy</ion-label>
          </ion-item>
          <ion-item
            lines="none"
            (click)="openLink('https://smartdietplanner.com/appinfo/')"
            class="ion-no-padding ion-margin-horizontal"
          >
            <ion-img src="assets/images/Artboard10.svg"></ion-img>
            <ion-label class="ion-margin-start">
              Source of information</ion-label
            >
          </ion-item>
          <ion-item
            lines="none"
            (click)="openLink('https://www.youtube.com/embed/14xMSfRY3-k')"
            class="ion-no-padding ion-margin-horizontal"
          >
            <!-- <ion-img src="assets/images/source-of-info-item.svg"></ion-img> -->
            <ion-icon name="logo-youtube"></ion-icon>
            <ion-label class="ion-margin-start"> App Preview</ion-label>
          </ion-item>
          <ion-item
            lines="none"
            (click)="rateus()"
            class="ion-no-padding ion-margin-horizontal"
          >
            <!-- <ion-img src="assets/images/refresh_grey.png"></ion-img> -->
            <ion-icon name="star-outline"></ion-icon>
            <ion-label class="ion-margin-start"> Rate Us</ion-label>
          </ion-item>

          <ion-item
            lines="none"
            (click)="downloadDietPlan()"
            class="ion-no-padding ion-margin-horizontal"
          >
            <ion-icon
              name="download-outline"
              [ngStyle]="{ opacity: !premiumPlanActive ? '0.5' : '1' }"
            ></ion-icon>
            <ion-label
              class="ion-margin-start"
              [ngStyle]="{ opacity: !premiumPlanActive ? '0.5' : '1' }"
              >Download Diet Plan</ion-label
            >
            <img
              src="./assets/img/premium.jpg"
              class="premium"
              *ngIf="!premiumPlanActive"
            />
            <img
              src="./assets/img/premium-crown.png"
              *ngIf="premiumPlanActive"
              class="premium"
              style="height: 50%; top: 10px"
            />
          </ion-item>

          <ion-item
            lines="none"
            (click)="restore()"
            *ngIf="isIOSDevice"
            class="ion-no-padding ion-margin-horizontal"
          >
            <ion-img src="assets/images/refresh_grey.png"></ion-img>
            <ion-label class="ion-margin-start"> Restore Purchase</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>
      <!-- <ion-list class="ion-no-padding menu-side" lines="none">
        <ion-menu-toggle auto-hide="true">
          <div class="d-flex-center py-6">
            <img class="user-image" src="assets/img/manjari-profile.svg" />
            <div>
              <p (click)="openLink('https://manjariwellness.com/about-us/')" class="about-menu">
                About Manjari Chandra
              </p>
              <p class="about-menu" (click)="appIntro()">
                App Intro
              </p>
            </div>
          </div>
          <ion-item [routerLink]="['notification']">
            <ion-icon name="notifications" slot="start" style="color:#707070"></ion-icon>
            <ion-label>Notifications setting</ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-icon name="share-social" slot="start" style="color:#707070"></ion-icon>
            <ion-label>Share with your friends</ion-label>
          </ion-item>
          <ion-item lines="none" (click)="openLink('https://smartdietplanner.com/terms')">
            <ion-icon name="document-text" slot="start" style="color:#707070"></ion-icon>
            <ion-label>Term and conditions</ion-label>
          </ion-item>
          <ion-item lines="none" (click)="openLink('https://smartdietplanner.com/policy')">
            <ion-icon name="document-lock" slot="start" style="color:#707070"></ion-icon>
            <ion-label>Privacy Policy</ion-label>
          </ion-item>
          <ion-item lines="none" (click)="openLink('https://smartdietplanner.com/appinfo/')">
            <ion-icon name="information" slot="start" style="color:#707070"></ion-icon>
            <ion-label> Source of information</ion-label>
          </ion-item>
          <ion-item lines="none" (click)="restore()" *ngIf="isIOSDevice">
            <ion-icon name="refresh-outline" slot="start" style="color:#707070"></ion-icon>
            <ion-label> Restore Purchase</ion-label>
          </ion-item>
          <br>
          <ion-item (click)="logout()" lines="none" class="ion-text-center">
            <ion-button mode="ios" size="medium" shape="round" style="--background:#01A3A4;border:1px solid #01A3A4; --color:#fff;border-radius: 25px;left: 26%;
              position: relative;">
              <ion-icon name="log-out" slot="start" style="color:#fff"></ion-icon>
              Logout
            </ion-button>
          </ion-item>
        </ion-menu-toggle>
      </ion-list> -->

      <!-- <ion-row class="ion-align-items-center">
          <ion-col size="2">
            <ion-button color="light" (click)="ShareLink('text')"><ion-icon name="share-social-outline"></ion-icon></ion-button>
          </ion-col>
          <ion-col size="2">
              <ion-button color="warning" (click)="SendEmail()"><ion-icon name="mail-outline"></ion-icon></ion-button>
          </ion-col>
          <ion-col size="2">
            <ion-button color="primary" (click)="ShareFacebook()"><ion-icon name="logo-facebook"></ion-icon></ion-button>
          </ion-col>
          <ion-col size="2">
              <ion-button color="success" (click)="ShareWhatsapp()"><ion-icon name="logo-whatsapp"></ion-icon></ion-button>
          </ion-col>
          <ion-col size="2">
            <ion-button  color="secondary" (click)="SendTwitter()"><ion-icon name="logo-twitter"></ion-icon></ion-button>
          </ion-col>   
          <ion-col size="2">
            <ion-button color="tertiary" (click)="SendInstagram()"><ion-icon name="logo-instagram"></ion-icon></ion-button>
          </ion-col>    
        </ion-row> -->
    </ion-content>
    <span class="ion-margin-horizontal version">Version 2.365</span>
    <ion-footer>
      <ion-toolbar>
        <ion-row (click)="logout()">
          <ion-col size="2">
            <ion-img
              src="assets/images/Artboard11.svg"
              style="height: 24px; width: 24px; margin-left: 13px"
            ></ion-img>
          </ion-col>
          <ion-col>Logout</ion-col>
        </ion-row>
      </ion-toolbar>
    </ion-footer>
  </ion-menu>
  <ion-router-outlet id="main-content" main></ion-router-outlet>
</ion-app>
